import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "value", "defaultValue", "valueChange", "onChange", "country", "label", "error", "errMessage"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useEffect, useState } from 'react';
import { PhoneNumberInput, useLocalTranslation } from '@jove-frontend/uikit';
import { InfoOutlined } from '@mui/icons-material';
import { Box, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { formatPhoneNumberIntl, isSupportedCountry } from 'react-phone-number-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JovePhoneNumberInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t; // $t('kit:quotes.phone_number')


  var className = props.className,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      onChange = props.onChange,
      country = props.country,
      _props$label = props.label,
      label = _props$label === void 0 ? 'Customer phone number' : _props$label,
      error = props.error,
      errMessage = props.errMessage,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue || ''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState(country),
      currentCountry = _useState2[0],
      setCurrentCountry = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    if ((country !== undefined || country !== null) && isSupportedCountry(country)) {
      setCurrentCountry(country);
    }
  }, [country]);
  /**
   * methods
   */

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    setInputValue(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsx(PhoneNumberInput, _objectSpread(_objectSpread({}, rest), {}, {
      className: "h-full w-full border border-[#0000003B]",
      label: label + (rest !== null && rest !== void 0 && rest.required ? ' *' : ''),
      value: formatPhoneNumberIntl(String(value === undefined ? inputValue : value || '')),
      country: currentCountry,
      onChange: valueChangeAction
    })), error && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center space-x-1",
      children: [/*#__PURE__*/_jsx(InfoOutlined, {
        className: "h-3 w-3 text-[#d32f2f]"
      }), /*#__PURE__*/_jsx(FormHelperText, {
        error: error,
        children: errMessage
      })]
    })]
  });
});
export var JovePhoneNumberInputControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JovePhoneNumberInput, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultValue: defaultValue,
      onChange: onChange,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JovePhoneNumberInput;